class Controller {
  constructor($element) {
    "ngInject";

    this.$element = $element;
  }

  onSearch(query) {
    const itemsPromise = this.onAutoCompleteSearch(query);
    return itemsPromise.then((items) =>
      items.map((item) => ({ ...item, new: true }))
    );
  }

  onSelect(item) {
    if (item) {
      this.items.push(item);
      this.searchText = "";
    }
  }

  removeItem(itemIndex) {
    this.items.splice(itemIndex, 1);

    this.focus();
  }

  focus() {
    this.$element.find("input").focus();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/searchableMultiSelect/searchableMultiSelect.controller.js